var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1331_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4226 15.5993C28.6083 15.5993 32.0013 12.2019 32.0013 8.01107C32.0013 3.82021 28.6083 0.422852 24.4226 0.422852C20.2369 0.422852 16.8438 3.82021 16.8438 8.01107C16.8438 12.2019 20.2369 15.5993 24.4226 15.5993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2081 0.422852H2.94957C1.32057 0.422852 0 1.74506 0 3.37608V12.6461C0 14.2771 1.32057 15.5993 2.94957 15.5993H12.2081C13.8371 15.5993 15.1576 14.2771 15.1576 12.6461V3.37608C15.1576 1.74506 13.8371 0.422852 12.2081 0.422852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2081 17.2861H2.94957C1.32057 17.2861 0 18.6083 0 20.2394V29.5093C0 31.1404 1.32057 32.4626 2.94957 32.4626H12.2081C13.8371 32.4626 15.1576 31.1404 15.1576 29.5093V20.2394C15.1576 18.6083 13.8371 17.2861 12.2081 17.2861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0518 17.2861H19.7934C18.1644 17.2861 16.8438 18.6083 16.8438 20.2394V29.5093C16.8438 31.1404 18.1644 32.4626 19.7934 32.4626H29.0518C30.6808 32.4626 32.0013 31.1404 32.0013 29.5093V20.2394C32.0013 18.6083 30.6808 17.2861 29.0518 17.2861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1331_3178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.c0027555eef7eba8bfa84dd25277cd51.svg";
export { ForwardRef as ReactComponent };